<script lang="ts">
  import type {MultipleChoiceQuestion, CurrentResponses, QuestionOnChange} from '../types';
  import {getDisplayValue} from '../utils';
  import Markdown from '../Markdown.svelte';
  export let question: MultipleChoiceQuestion;
  export let pageQuestionIdx: string;
  export let onChange: QuestionOnChange;
  export let currentResponses: CurrentResponses;

  $: label = getDisplayValue<MultipleChoiceQuestion>(currentResponses, question, 'label') as string;
  $: options = getDisplayValue<MultipleChoiceQuestion>(currentResponses, question, 'options') as string[];
  $: value = currentResponses[pageQuestionIdx];
</script>

<fieldset>
  <div class="flex flex-wrap justify-center">
    {#each options as option, idx}
      <div
        class="flex items-center relative px-4 border-2 border-white rounded hover:border-sky-400 justify-center dark:border-zinc-900 mx-2 my-1"
      >
        <input
          type="radio"
          name={label}
          id={`option-${pageQuestionIdx}-${idx}`}
          bind:value={option}
          on:change={() => onChange({newValue: option})}
          checked={option === value}
        />
        <div class="mr-4 ml-1  pointer-events-none"><Markdown text={option} /></div>
        <label for={`option-${pageQuestionIdx}-${idx}`} class="absolute w-full h-full" />
      </div>
    {/each}
  </div>
</fieldset>
